import Vue from "vue";
import Vuex, { createLogger } from 'vuex';
import VuexPersistedstate from "vuex-persistedstate"; // TODO safety concenrs ?
import paths from "./persist-paths";

import ShoppingCart from "./modules/shopping-cart";
import Coupon from "./modules/coupon";
import ReferAFriend from "./modules/refer-a-friend";
import Product from "./modules/product";
import Payment from "./modules/payment";
import SignUp from "./modules/sign-up";
import Address from "./modules/address";
import Checkout from "./modules/checkout";
import Tax from './modules/tax';
import Common from "./modules/common";
import Config from "./modules/config";
import Pbx from "./modules/product/pbx";
import PartnerRefer from "./modules/partner-refer";
import LeadCreation from './modules/lead-creation';
import Preview from './modules/preview';
import FraudRisk from './modules/fraud-risk';
import Invoice from './modules/invoice';
import GlobalStatus from './modules/global-status';
import UseVerification from "./modules/use-verification";
import Promotion from "./modules/promotion";
import Devices from "./modules/product/devices";
import { isDebug } from "@/utils";
import { nStorage, removeCouponIfConditionMet } from '@/common/NStorage';

Vue.use(Vuex);

removeCouponIfConditionMet(nStorage, nStorage.key);

const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    ShoppingCart,
    Coupon,
    ReferAFriend,
    Product,
    Payment,
    SignUp,
    Address,
    Checkout,
    Common,
    Tax,
    Config,
    PartnerRefer,
    LeadCreation,
    Pbx,
    Preview,
    FraudRisk,
    GlobalStatus,
    Invoice,
    UseVerification,
    Promotion,
    Devices,
  },
  plugins: [VuexPersistedstate({
    key: nStorage.key,
    paths,
    storage: nStorage,
  }), isDebug && createLogger()].filter(Boolean),
});

window.$store = store;

export default store;
